import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, ModelData, ModalSize, QueryParameter, ModalService } from 'yt-ng-framework';
import { Komitent } from './komitent';
import { ActivatedRoute } from '@angular/router';
import { KomitentUpdateComponent } from './komitent-update.component';
import { Input } from '@angular/core';
import { ViewChild } from '@angular/core';
import { FirmaKodKupcaComponent } from './firma-kod-kupca/firma-kod-kupca.component';
import { KomitentZrcUpdateComponent } from './komitent-zrc/komitent-zrc-update.component';
import { KomitentUpdateFromNbsComponent } from './komitent-update-from-nbs/komitent-update-from-nbs.component';

@Component({
  selector: 'yt-komitent-tab-update',
  templateUrl: './komitent-tab-update.component.html'
})
export class KomitentTabUpdateComponent extends BaseTabsUpdateComponent<Komitent> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<Komitent>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }
  saveDisabled: boolean = false;

  ngOnInit() {
    super.ngOnInit();
    this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
    this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
  }
  Reset(): void {
    this.baseUpdateComponent.Reset(true).subscribe((result) => {
      if (result) {
        // console.log('Restore successfully executed');
      } else {
        // console.log('Restore was cancelled by the user');
      }
    });
  }

  @ViewChild('baseUpdate', { static: true }) komBaseUpdate: KomitentUpdateComponent

  SetSifraFirmeKodKomitenta(){
    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Md;
    modelData.UpdateComponent = FirmaKodKupcaComponent;

    let firmaSifraKodKupca: string = this.baseUpdateComponent.baseFormGroup.get('FirmaSifraKodKupca').value;
    let firmaSifraKodKupcaParameter = new QueryParameter('FirmaSifraKodKupca', firmaSifraKodKupca);

    if(modelData){
      this.modalService.ShowModal(0, modelData, null, true, [
        firmaSifraKodKupcaParameter
      ])
      .result.then( result => {
        this.komBaseUpdate.SetFirmaKodKupca = result;
      },
      () =>{})
    }
  }

  UpdateKomitentPoPib(){
    let _modelData = new ModelData(null);
    _modelData.ModalSize = ModalSize.Lg;
    _modelData.UpdateComponent = KomitentUpdateFromNbsComponent;

    let pib: string = this.baseUpdateComponent.baseFormGroup.get("Pib").value;
    let pibParameter = new QueryParameter("Pib", pib);
    let id: string = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    let idParameter = new QueryParameter("ID", id);

    // if (modelData){
    //   this.modalService.ShowModal(0,modelData,null,true, 
    //     [pibParameter
    //     ,idParameter])
    //   .result
    //   .then((item)=>{
    //     if(item)
    //       this.klik();
    //     //let qq:any={};
    //     // qq.ID=3981
    //     // qq.BrojDokumenta="111";
    //     // qq.OsvezivogStatusa=true;
    //     // this.tabsContainerService.EmitItem(qq);
    //   }, (reason) => {

    //   }
      
    //   )  
    // }

    if (_modelData) {
      this.modalService
        .ShowModal(0, _modelData, null, true, [
          pibParameter
         ,idParameter
        ])
        .result.then(
          (item) => {
            //alert("Modal success at:")
            //this.baseUpdateComponent['detailList'].RefreshData();
          },
          (reason) => {
            this.baseUpdateComponent['detailList'].RefreshData();
          }
        );
    }
  }
}


